/* Vaultier motion layer — staggered scroll reveals via IntersectionObserver.
   Stagger/threshold/rootMargin match the VAULTIER handoff §6.4 exactly. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  function init() {
    var targets = [];
    var sections = document.querySelectorAll('#MainContent .shopify-section');

    sections.forEach(function (section, index) {
      // Hero animates itself via CSS.
      if (index === 0 && section.className.indexOf('hero-wrapper') !== -1) return;

      var items = section.querySelectorAll('.resource-list__item');
      if (items.length > 0) {
        // Product grids: stagger the cards instead of the whole section.
        items.forEach(function (item, i) {
          item.classList.add('v-reveal');
          item.style.setProperty('--v-delay', Math.min(i, 6) * 80 + 'ms');
          targets.push(item);
        });
        return;
      }

      section.classList.add('v-reveal');
      targets.push(section);
    });

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('v-in');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.15 }
    );

    targets.forEach(function (t) {
      io.observe(t);
    });

    // Safety net: reveal anything still hidden after 4s (e.g. off-screen iframes).
    setTimeout(function () {
      targets.forEach(function (t) {
        t.classList.add('v-in');
      });
    }, 4000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
